<template>
  <div class="row">
    <div class="col-lg-4 col-xxxl-3 mb-25">
      <div class="card border-0 rounded-0 bg-white letter-spacing chat-sidebar">
        <div class="card-body">
          <!-- <form class="search-box position-relative">
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0 border-0"
              placeholder="Search message"
            />
            <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form> -->
          <!-- <div class="chat-tabs">
            <router-link
              to="/chat"
              class="text-decoration-none fw-medium transition text-center d-block"
            >
              Private
            </router-link>
            <router-link
              to="/chat-group"
              class="text-decoration-none fw-medium transition text-center d-block"
            >
              Group
            </router-link>
            <router-link
              to="/chat-contact"
              class="active text-decoration-none fw-medium transition text-center d-block"
            >
              Contact
            </router-link>
          </div> -->
          <div class="chat-users-list mt-0">
            <div class="p-25"  v-if="patients === undefined">
              <SpinnerLoading/>
            </div>
            <template v-for="(values, key) in patient_groups" :key="key">
              <div class="box">
              <span class="d-inline-block rounded-circle text-center text-primary fw-bold">
                {{key}}
              </span>
            </div>
            <div class="single-user-item pt-15 pb-15 position-relative" v-for="patient in values" :key="patient.id" :id="patient.id" :class="{'active': patient.id === patient_id}" @click="select(patient)">
                <div class="d-flex align-items-center">
                  <!-- <img src="@/assets/images/user/user4.jpg" width="30" height="30" class="rounded-circle" alt="user" /> -->
                  <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium ms-12">
                    {{patient.lastname}} {{ patient.firstname }}
                  </span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-xxxl-9 mb-25">
      <router-view></router-view>
      <!-- <MessagesBody :patient="selected_patient" /> -->
    </div>
  </div>
</template>
<style>
.chat-card .card-body .chat-list {
  height: 485px;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
// import MessagesBody from '@/components/FK/Messages/MessagesBody.vue';
import { PatientInfo } from '@/utils/models/user.model';
import API from '@/services/api/api.service';
import SpinnerLoading from "@/components/Widgets/Spinner.vue";

export default defineComponent({
  name: "MessagesView",
  components: {
    SpinnerLoading,
  },
  data: function () {
    return {
      patients: undefined,
    } as {
      patients?: PatientInfo[]
    }
  },
  mounted() {
    this.loadPatients();
  },
  methods: {
    loadPatients() {
      this.patients = undefined;
      API.getPatients({ page: 0 }).then((response) => {
        if (response.data.success == true) {
          this.patients = response.data.data;
        } else {
          this.patients = [];
        }
      }).catch((error) => {
        this.patients = [];
      });
    },
    select(patient: PatientInfo) {
      this.$router.push({path:`/messages/${patient.id}`});
    }
  },
  computed: {
    patient_id() {
      return this.$route.params.id;
    },
    patient_groups(): {[key: string]: PatientInfo[]} {
      return this.oredered_patients.reduce((acc, cur) => {
        const firstLetter = cur.lastname[0].toUpperCase();
        return { ...acc, [firstLetter]: [...(acc[firstLetter] || []), cur] };
      }, {} as {[key: string]: PatientInfo[]} );
    },
    oredered_patients(): PatientInfo[] {
      return (((this.patients ?? []) as PatientInfo[])).sort(function(a, b) {
    var textA = a.lastname.toUpperCase();
    var textB = b.lastname.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
    }
  }
});
</script>